module.exports = function() {
  return new Worker(__webpack_public_path__ + "e2dd7c877e3b39783928.worker.js");
};